'use client';

import type { ReactNode } from 'react';
import { getPremiumServiceHref, type PremiumServiceAccess, type PremiumServiceKey } from '../../premiumServiceLinks';
import styles from './SiteNav.module.scss';

export interface PremiumServicesLinkProps {
  access: PremiumServiceAccess;
  label?: ReactNode;
  className?: string;
  onLinkClick?: (service: PremiumServiceKey) => void;
}

export const PremiumServicesLink = ({
  access,
  label = 'Premium Services',
  className = '',
  onLinkClick,
}: PremiumServicesLinkProps) => (
  <a
    className={
      styles.premiumTrigger +
      " relative inline-flex h-[38px] flex-none cursor-pointer appearance-none items-center whitespace-nowrap rounded-lg border-0 bg-[linear-gradient(180deg,#3b8cff_0%,#1a79ff_45%,#0b57d0_100%)] px-4 font-[inherit] text-sm font-bold tracking-[0.01em] text-white no-underline [text-shadow:0_1px_1px_rgba(0,0,0,0.18)] transition-[filter] duration-200 ease-out after:pointer-events-none after:absolute after:inset-0 after:rounded-lg after:bg-[linear-gradient(110deg,transparent_35%,rgba(255,255,255,0.35)_50%,transparent_65%)] after:content-[''] after:-translate-x-full hover:brightness-105 hover:after:translate-x-full hover:after:transition-transform hover:after:duration-700 motion-reduce:hover:after:transition-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--hubnav-accent)] " +
      className
    }
    style={{ boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.28)' }}
    href={getPremiumServiceHref('services', access)}
    aria-label="Premium Services"
    onClick={() => onLinkClick?.('services')}
  >
    {label}
  </a>
);
